import { styled } from 'styled-components';
import { HeaderItem } from '../HeaderRightCornerContent/styles';

export const HeaderCommunitiesItemContainer = styled(HeaderItem)`
  min-width: 126px;
  justify-content: right;
  z-index: 3;
  position: relative;
`;
